import { render, staticRenderFns } from "./OrderItems.vue?vue&type=template&id=e6be9f76&"
import script from "./OrderItems.vue?vue&type=script&lang=js&"
export * from "./OrderItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6be9f76')) {
      api.createRecord('e6be9f76', component.options)
    } else {
      api.reload('e6be9f76', component.options)
    }
    module.hot.accept("./OrderItems.vue?vue&type=template&id=e6be9f76&", function () {
      api.rerender('e6be9f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/OrderItems.vue"
export default component.exports